<template>
  <div class="content">
    <Header title="Tłumaczenia"></Header>
    <div class="content__body">
      <div class="translate">
        <div class="translate__content">
          <div class="row shortcuts">
            <a class="shortcuts__box " @click.prevent="exportTranslate">
              <div class="shortcuts__content">
                <img class="shortcuts__icon" src="../iconfont/export_icon.svg"/>
                <div class="shortcuts__text">export tłumaczeń</div>
              </div>
            </a>
            <loader :visible="isLoading"/>


            <a class="shortcuts__box el-icon-remove-outline files-drop-area__button"
               @click="$refs.fileUpload.click()">
              <div class="shortcuts__content">
                <img class="shortcuts__icon" src="../iconfont/import_icon.svg"/>
                <div class="shortcuts__text">import tłumaczeń</div>
              </div>
            </a>
            <input
                class="files-upload__add-files-input"
                ref="fileUpload"
                type="file"
                @change="handleFileUpload"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./parts/Header.vue";
import axios from "axios";
import Loader from "@/components/parts/Loader.vue";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export default {
  data() {
    return {
      logs: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1,
        data: {},
      },
      isLoading: false,
      showImportModal: false,
      isDragOver: false,
      files: [],
      fileTypes: [],
      forms: [],
    };
  },
  components: {Loader, Header},
  methods: {
    exportTranslate() {
      this.isLoading = true;

      axios
          .get(API_BASE_URL + "/translation", {
            responseType: "blob",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                'spim_translation.xlsx'
            );
            document.body.appendChild(fileLink);

            fileLink.click();
            this.isLoading = false;

          });


    },
    handleFileUpload(event) {
      this.importFile = event.target.files[0];
      this.importTranslate();
    },
    importTranslate() {
      if (!this.importFile) return;

      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', this.importFile)
      axios.post(API_BASE_URL + "/translation", formData,{
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
          .then(response => {
            this.$root.$emit("noticesBox", {
              type: "success",
              message: response.data.message,
            });
      })
          .catch(error =>{
            let message = 'Wystąpił błąd podaczas importu pliku';
            if( error.response.data.message){
              message = 'Nieprawidłowy format pliku'
            }
            this.$root.$emit("noticesBox", {
              type: "error",
              message: message
            });
          })
          .finally(() => {
            this.isLoading = false;
          })
    },
  },

};
</script>
